export enum Mode {
    View = 'view',
    Edit = 'edit',
    Delete = 'delete',
    Create = 'create',
    Preview = 'preview',
}